import React, { useCallback, useEffect, useMemo, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import { useAxios } from '../../contexts/axios';
import { BACKEND_URL } from '../../configs';
import { useAuth } from '../../contexts/auth';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { ExportToCsv } from 'export-to-csv';
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import SearchDD from '../SearchDD';
import Chip from '@mui/material/Chip';
import TimePickerInput from '../costing/TimePickerInput';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    MenuItem,
    Stack,
    TextField,
    Select,
    Tooltip,
    Typography,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PendingIcon from '@mui/icons-material/Pending';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';
const StatusPill = ({ value }) => {
    return (
        <>
            <div className="inline-flex">
                <div style={{ marginRight: '2px' }}>
                    {value === 'FAILURE' ? (
                        <CancelIcon color="error" style={{ width: '18px' }} />
                    ) : value === 'SUCCESS' ? (
                        <CheckCircleIcon
                            color="success"
                            style={{ width: '18px' }}
                        />
                    ) : value === 'UPDATING' ? (
                        <CircularProgress color="warning" size={18} />
                    ) : value === 'STARTED' ? (
                        <AlarmOnIcon
                            style={{ width: '18px' }}
                            color="primary"
                        />
                    ) : (
                        <PendingIcon
                            style={{ width: '18px' }}
                            color="disabled"
                        />
                    )}
                </div>
                {value === 'FAILURE'
                    ? 'Failed'
                    : value === 'SUCCESS'
                    ? 'Success'
                    : value === 'UPDATING'
                    ? 'Updating'
                    : value === 'STARTED'
                    ? 'Started'
                    : 'Has not run yet'}
                <div></div>
            </div>
        </>
    );
};

function getTimeDifference(time1, time2) {
    //console.log((time2?.getTime() - time1?.getTime()) / 3600000);
    if (time1.getTime() > time2.getTime())
        return (time1?.getTime() - time2?.getTime()) / 3600000;
    else return (24 - (time2?.getTime() - time1?.getTime()) / 3600000) % 24;
}

function compareTime(scaleUpFrequency, scaleDownFrequency) {
    var time1 = scaleUpFrequency.getTime() / 1000;
    var time2 = scaleDownFrequency.getTime() / 1000;
    if (Math.abs(time1 - time2) <= 1800) {
        return true;
    }
    return false;
}

/*function get(object, key, default_value) {
    if (Object.keys(object).includes(key)) {
        if (object[key] === '') {
            return default_value;
        } else {
            return object[key];
        }
    } else {
        return default_value;
    }
}*/

function parseCron(cron) {
    const parser = require('cron-parser');
    var cronExpression = cron;
    //console.log(cronExpression);
    var interval = parser.parseExpression(cronExpression).next();
    //console.log(interval.getDay());
    var res = `${interval.getDate().toString()}/${(
        interval.getMonth() + 1
    ).toString()}/${interval.getFullYear().toString()} ${
        interval.getHours() > 12
            ? (interval.getHours() - 12).toString()
            : interval.getHours().toString()
    }:${interval.getMinutes().toString()}:00 ${
        interval.getHours() >= 12 ? 'PM' : 'AM'
    }`;
    //console.log(interval);
    return res;
}

function getTime(cron) {
    const parser = require('cron-parser');
    var cronExpression = cron;
    //console.log(cronExpression);
    var interval = parser.parseExpression(cronExpression).next().toISOString();
    return new Date(interval);
}

function parseTime(Time) {
    var date = Time.split('T')[0].split('-');
    var time = Time.split('T')[1].split(':');
    var hr = parseInt(time[0]);
    var res = `${date[2]}/${date[1]}/${date[0]} ${hr > 12 ? hr - 12 : hr}:${
        time[1]
    }:${time[2]} ${hr >= 12 ? 'PM' : 'AM'}`;
    //console.log(interval);
    return res;
}
function getCron(Time) {
    var time = new Date(Time);
    time.setHours(time.getHours() + 5);
    time.setMinutes(time.getMinutes() + 30);
    time = time.toISOString();
    var minuteHour = time.split('T')[1].split(':');
    var cron = `${minuteHour[1]} ${minuteHour[0]} * * *`;
    return cron;
}
function getCronDifference(cron1, cron2) {
    const parser = require('cron-parser');
    var time1 = parser.parseExpression(cron1).next();
    var time2 = parser.parseExpression(cron2).next();
    //(time1, time2);
    //console.log(getTimeDifference(time1,time2));
    return getTimeDifference(time1, time2);
}
const mongoCostPerHour = {
    M10: 0.1,
    M20: 0.23,
    M30: 0.53,
    M40: 1.03,
    M50: 1.99,
    M60: 3.95,
    M80: 7.36,
    M140: 11.46,
};

function getPerHourCostDifference(config1, config2) {
    if (config1 != null && typeof config1 === 'object' && config2 != null && typeof config2 === 'object') {
        var c1 = config1.datasetSizeInGb != null ? config1.datasetSizeInGb : 0;
        var c2 = config2.datasetSizeInGb != null ? config2.datasetSizeInGb : 0;
        var t1 = config1.throughputMeasurementValue != null ? config1.throughputMeasurementValue : 0;
        var t2 = config2.throughputMeasurementValue != null ? config2.throughputMeasurementValue : 0;
        return Math.abs(c1 - c2) + Math.abs(t1 - t2) * 0.001;
    }
    return Math.abs((mongoCostPerHour[config1] || 0) - (mongoCostPerHour[config2] || 0));
}

function getRedisConfigDisplay(config) {
    if (config == null) return { gb: null, ops: null };
    if (typeof config !== 'object') return { gb: null, ops: null };
    var gb = config.datasetSizeInGb ?? config.dataset_size_in_gb ?? null;
    var ops = config.throughputMeasurementValue ?? config.throughput_measurement_value ?? null;
    return { gb, ops };
}

function formatRedisConfig(config) {
    var { gb, ops } = getRedisConfigDisplay(config);
    if (gb == null && ops == null) return config != null && typeof config === 'object' ? JSON.stringify(config) : String(config ?? '');
    return 'datasetSizeInGb: ' + (gb ?? '-') + ', throughputMeasurementValue: ' + (ops ?? '-') + ' (ops/sec)';
}
const distributionsIndex = {
    M10: 0,
    M20: 1,
    M30: 2,
    M40: 3,
    M50: 4,
    M60: 5,
    M80: 6,
    M100: 7,
    M140: 8,
    M200: 9,
    M300: 10,
    R40: 11,
    R50: 12,
    R60: 13,
    R80: 14,
    R200: 15,
    R300: 16,
    R400: 17,
    R700: 18,
    M40_NVME: 19,
    M50_NVME: 20,
    M60_NVME: 21,
    M80_NVME: 22,
    M200_NVME: 23,
    M400_NVME: 24,
};
const distributions = [
    'M10',
    'M20',
    'M30',
    'M40',
    'M50',
    'M60',
    'M80',
    'M100',
    'M140',
    'M200',
    'M300',
    'R40',
    'R50',
    'R60',
    'R80',
    'R200',
    'R300',
    'R400',
    'R700',
    'M40_NVME',
    'M50_NVME',
    'M60_NVME',
    'M80_NVME',
    'M200_NVME',
    'M400_NVME',
];

// Normalize Redis instances API response: key by databaseName for dropdown
// API: GET ${BACKEND_URL}/redis/instances returns array of { databaseName, ... } or object keyed by databaseName
function normalizeRedisClusters(data) {
    if (!data) return {};
    if (!Array.isArray(data)) return typeof data === 'object' ? data : {};
    const out = {};
    for (let i = 0; i < data.length; i++) {
        const item = data[i];
        const key = item?.databaseName ?? item?.database_name ?? item?.name ?? item?.clusterName ?? item?.instanceId ?? item?.id ?? String(i);
        out[key] = item;
    }
    return out;
}

const RedisTbasTable = () => {
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [clusters, setClusters] = useState([]);
    const [clustersDup, setClustersDup] = useState([]);
    const [validationErrors, setValidationErrors] = useState({});
    const [editLoader, setEditLoader] = useState([]);
    const [approveLoader, setApproveLoader] = useState([]);
    const [dataLoader, setDataLoader] = useState(false);
    const axios = useAxios();
    const { isAdminApprover } = useAuth();
    async function call(url, data, method, setloading, index) {
        if (index === -1) {
            setloading(true);
        } else {
            if (method === 'GET') {
                approveLoader[index] = true;
                setloading(approveLoader);
            } else {
                editLoader[index] = true;
                setloading(editLoader);
            }
        }
        var requestOptions = {};
        if (method === 'GET') {
            requestOptions = {
                url: `${BACKEND_URL}/redis/tbas${url}`,
                method: method,
            };
        } else {
            requestOptions = {
                url: `${BACKEND_URL}/redis/tbas${url}`,
                method: method,
                data: data,
            };
        }
        await axios(requestOptions).then(() => {
            if (index === -1) {
                setloading(false);
            } else {
                if (method === 'GET') {
                    approveLoader[index] = false;
                    setloading(approveLoader);
                } else {
                    editLoader[index] = false;
                    setloading(editLoader);
                }
                window.location.reload(false);
            }
        });
    }

    async function getData() {
        setDataLoader(true);
        var requestOptions = {
            url: `${BACKEND_URL}/redis/tbas`,
            method: 'GET',
        };
        await axios(requestOptions)
            .then(function (res) {
                var raw = res.data;
                // Support: array, single object (wrap in array), or wrapped { data: [...] }
                var data;
                if (Array.isArray(raw)) {
                    data = raw;
                } else if (raw != null && typeof raw === 'object' && !Array.isArray(raw)) {
                    if (Array.isArray(raw.data)) {
                        data = raw.data;
                    } else if (Array.isArray(raw.results)) {
                        data = raw.results;
                    } else if (Array.isArray(raw.tbas)) {
                        data = raw.tbas;
                    } else if (raw.databaseName != null || raw.scaleUpFrequency != null || raw.clusterName != null) {
                        data = [raw];
                    } else {
                        data = [];
                    }
                } else {
                    data = [];
                }
                var tempLoader1 = [];
                var tempLoader2 = [];
                for (var i = 0; i < data.length; i++) {
                    tempLoader1.push(false);
                    tempLoader2.push(false);
                    // Table uses clusterName; API may return databaseName
                    if (data[i].databaseName != null && data[i].clusterName == null) {
                        data[i].clusterName = data[i].databaseName;
                    }
                    try {
                        var upFreq = data[i]['scaleUpFrequency'];
                        var downFreq = data[i]['scaleDownFrequency'];
                        var cron1 = typeof upFreq === 'string' && upFreq.indexOf('T') !== -1 ? getCron(upFreq) : upFreq;
                        var cron2 = typeof downFreq === 'string' && downFreq.indexOf('T') !== -1 ? getCron(downFreq) : downFreq;
                        data[i]['estimatedSaving'] =
                            (getCronDifference(cron1, cron2) || 0) *
                            (getPerHourCostDifference(
                                data[i]['scaleUpConfig'],
                                data[i]['scaleDownConfig']
                            ) || 0) *
                            30;
                    } catch (e) {
                        data[i]['estimatedSaving'] = 0;
                    }
                }
                setTableData(data);
                setEditLoader(tempLoader1);
                setApproveLoader(tempLoader2);
            })
            .catch((err) => {
                setTableData([]);
            })
            .finally(() => {
                setDataLoader(false);
            });
    }

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        axios({ url: `${BACKEND_URL}/redis/instances` })
            .then(function (res) {
                var temp = normalizeRedisClusters(res.data);
                for (var i = 0; i < tableData.length; i++) {
                    delete temp[tableData[i]['clusterName']];
                }
                setClusters(temp);
            })
            .catch(() => setClusters({}));
    }, [tableData]);

    useEffect(() => {
        axios({ url: `${BACKEND_URL}/redis/instances` })
            .then(function (res) {
                setClustersDup(normalizeRedisClusters(res.data));
            })
            .catch(() => setClustersDup({}));
    }, []);

    // Build payload matching RedisTbasConfig (databaseName, databaseId, subscriptionId, scaleUpConfig/scaleDownConfig as RedisConfig, etc.)
    const buildRedisTbasPayload = (values, rowOrCluster) => {
        var databaseName = values['databaseName'] ?? values['clusterName'] ?? (rowOrCluster?.getValue ? rowOrCluster.getValue('databaseName') ?? rowOrCluster.getValue('clusterName') : rowOrCluster);
        var databaseId = values['databaseId'] ?? (rowOrCluster?.original?.databaseId ?? (rowOrCluster?.getValue ? rowOrCluster.getValue('databaseId') : undefined)) ?? '';
        var subscriptionId = values['subscriptionId'] ?? (rowOrCluster?.original?.subscriptionId ?? (rowOrCluster?.getValue ? rowOrCluster.getValue('subscriptionId') : undefined)) ?? '';
        var scaleUpFreq = typeof values['scaleUpFrequency'] === 'string' && values['scaleUpFrequency'].indexOf('T') !== -1 ? getCron(values['scaleUpFrequency']) : (values['scaleUpFrequency'] ?? '');
        var scaleDownFreq = typeof values['scaleDownFrequency'] === 'string' && values['scaleDownFrequency'].indexOf('T') !== -1 ? getCron(values['scaleDownFrequency']) : (values['scaleDownFrequency'] ?? '');
        return {
            databaseName: databaseName,
            databaseId: String(databaseId),
            subscriptionId: String(subscriptionId),
            scaleUpFrequency: scaleUpFreq,
            scaleUpConfig: values['scaleUpConfig'],
            scaleDownFrequency: scaleDownFreq,
            scaleDownConfig: values['scaleDownConfig'],
            slackChannelId: values['slackChannelId'] ?? '',
            scaleUpStatus: values['scaleUpStatus'] ?? '',
            scaleDownStatus: values['scaleDownStatus'] ?? '',
            scaleUpLastRun: values['scaleUpLastRun'] ?? '',
            scaleUpNextRun: values['scaleUpNextRun'] ?? (scaleUpFreq ? parseCron(scaleUpFreq) : ''),
            scaleDownLastRun: values['scaleDownLastRun'] ?? '',
            scaleDownNextRun: values['scaleDownNextRun'] ?? (scaleDownFreq ? parseCron(scaleDownFreq) : ''),
            approvedStatus: values['approvedStatus'] ?? 'False',
            creatorEmail: values['creatorEmail'] ?? '',
        };
    };

    const handleCreateNewRow = (values) => {
        if (
            !isAdminApprover() &&
            !window.confirm(
                `Once you confirm you won't be able to change. Are you sure you want to add this Tbas Config?`
            )
        ) {
            return;
        }
        var val = buildRedisTbasPayload(values, null);
        call('', val, 'POST', setDataLoader, -1);
        var temp = tableData;
        val['estimatedSaving'] =
            getCronDifference(
                val['scaleUpFrequency'],
                val['scaleDownFrequency']
            ) *
            getPerHourCostDifference(
                val['scaleUpConfig'],
                val['scaleDownConfig']
            ) *
            30;
        val['clusterName'] = val['databaseName'];
        temp.push(val);
        setTableData([...temp]);
    };

    const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
        var scaleUpConfig = values['scaleUpConfig'];
        var scaleDownConfig = values['scaleDownConfig'];
        if (values['scaleUpDatasetSizeInGb'] != null && values['scaleUpThroughputOps'] != null) {
            scaleUpConfig = {
                datasetSizeInGb: Number(values['scaleUpDatasetSizeInGb']),
                throughputMeasurementValue: Number(values['scaleUpThroughputOps']),
            };
        }
        if (values['scaleDownDatasetSizeInGb'] != null && values['scaleDownThroughputOps'] != null) {
            scaleDownConfig = {
                datasetSizeInGb: Number(values['scaleDownDatasetSizeInGb']),
                throughputMeasurementValue: Number(values['scaleDownThroughputOps']),
            };
        }
        var isRedisConfig = scaleUpConfig != null && typeof scaleUpConfig === 'object' && scaleDownConfig != null && typeof scaleDownConfig === 'object';

        if (!isRedisConfig) {
            var configMaxIndex =
                distributionsIndex[
                    clustersDup[values['clusterName']]?.max_instance_size
                ];
            var configMinIndex =
                distributionsIndex[
                    clustersDup[values['clusterName']]?.min_instance_size
                ];
            var valueMaxIndex = distributionsIndex[scaleUpConfig];
            var valueMinIndex = distributionsIndex[scaleDownConfig];

            if (valueMaxIndex > configMaxIndex || valueMinIndex < configMinIndex) {
                alert(
                    `ScaleUp config value should be <= ${
                        clustersDup[values['clusterName']]?.max_instance_size
                    } and ScaleDown config value should be >= ${
                        clustersDup[values['clusterName']]?.min_instance_size
                    }`
                );
                return;
            }
            if (valueMaxIndex <= valueMinIndex) {
                alert(
                    'ScaleUp config value should be greater than ScaleDown config value'
                );
                return;
            }
        }
        // if (
        //     compareTime(
        //         getTime(values['scaleUpFrequency']),
        //         getTime(values['scaleDownFrequency'])
        //     )
        // ) {
        //     alert(
        //         'Difference between ScaleUp and ScaleDown Frequency should be atleast greater than 30 min'
        //     );
        //     return;
        // }

        if (!Object.keys(validationErrors).length) {
            var temp = tableData[row.index];
            var dbName = values['databaseName'] ?? values['clusterName'] ?? temp['databaseName'] ?? temp['clusterName'];
            tableData[row.index] = {
                databaseName: dbName,
                databaseId: values['databaseId'] ?? temp['databaseId'],
                subscriptionId: values['subscriptionId'] ?? temp['subscriptionId'],
                clusterName: dbName,
                creatorEmail: values['creatorEmail'],
                scaleUpStatus:
                    values['scaleUpFrequency'] !==
                    tableData[row.index]['scaleUpFrequency']
                        ? ''
                        : values['scaleUpStatus'],
                scaleDownStatus:
                    values['scaleDownFrequency'] !==
                    tableData[row.index]['scaleDownFrequency']
                        ? ''
                        : values['scaleDownStatus'],
                scaleUpFrequency: values['scaleUpFrequency'],
                scaleUpConfig: scaleUpConfig ?? values['scaleUpConfig'],
                scaleDownFrequency: values['scaleDownFrequency'],
                scaleDownConfig: scaleDownConfig ?? values['scaleDownConfig'],
                estimatedSaving:
                    getCronDifference(
                        values['scaleUpFrequency'],
                        values['scaleDownFrequency']
                    ) *
                    getPerHourCostDifference(
                        scaleUpConfig ?? values['scaleUpConfig'],
                        scaleDownConfig ?? values['scaleDownConfig']
                    ) *
                    30,
                slackChannelId: values['slackChannelId'],
                scaleUpLastRun:
                    values['scaleUpFrequency'] !==
                    tableData[row.index]['scaleUpFrequency']
                        ? ''
                        : values['scaleUpLastRun'],
                scaleUpNextRun:
                    values['scaleUpFrequency'] !==
                    tableData[row.index]['scaleUpFrequency']
                        ? parseCron(values['scaleUpFrequency'])
                        : values['scaleUpNextRun'],
                scaleDownLastRun:
                    values['scaleDownFrequency'] !==
                    tableData[row.index]['scaleDownFrequency']
                        ? ''
                        : values['scaleDownLastRun'],
                scaleDownNextRun:
                    values['scaleDownFrequency'] !==
                    tableData[row.index]['scaleDownFrequency']
                        ? parseCron(values['scaleDownFrequency'])
                        : values['scaleDownNextRun'],
                approvedStatus: values['approvedStatus'],
            };
            var putPayload = buildRedisTbasPayload(
                {
                    ...values,
                    scaleUpConfig: scaleUpConfig ?? values['scaleUpConfig'],
                    scaleDownConfig: scaleDownConfig ?? values['scaleDownConfig'],
                    databaseName: values['databaseName'] ?? values['clusterName'] ?? temp['databaseName'] ?? temp['clusterName'],
                    databaseId: values['databaseId'] ?? temp['databaseId'],
                    subscriptionId: values['subscriptionId'] ?? temp['subscriptionId'],
                    scaleUpLastRun: values['scaleUpFrequency'] !== temp['scaleUpFrequency'] ? '' : (values['scaleUpLastRun'] ?? temp['scaleUpLastRun']),
                    scaleUpNextRun: values['scaleUpFrequency'] !== temp['scaleUpFrequency'] ? parseCron(values['scaleUpFrequency']) : (values['scaleUpNextRun'] ?? temp['scaleUpNextRun']),
                    scaleDownLastRun: values['scaleDownFrequency'] !== temp['scaleDownFrequency'] ? '' : (values['scaleDownLastRun'] ?? temp['scaleDownLastRun']),
                    scaleDownNextRun: values['scaleDownFrequency'] !== temp['scaleDownFrequency'] ? parseCron(values['scaleDownFrequency']) : (values['scaleDownNextRun'] ?? temp['scaleDownNextRun']),
                    scaleUpStatus: values['scaleUpFrequency'] !== temp['scaleUpFrequency'] ? '' : (values['scaleUpStatus'] ?? temp['scaleUpStatus']),
                    scaleDownStatus: values['scaleDownFrequency'] !== temp['scaleDownFrequency'] ? '' : (values['scaleDownStatus'] ?? temp['scaleDownStatus']),
                },
                row
            );
            call('', putPayload, 'PUT', setEditLoader, row.index);
            setTableData([...tableData]);
        }
        exitEditingMode();
    };

    const handleApprove = useCallback(
        (row) => {
            var dbName = row.original?.databaseName ?? row.getValue('databaseName') ?? row.getValue('clusterName') ?? 'this config';
            if (
                !window.confirm(
                    `Are you sure you want to ${
                        row.getValue('approvedStatus') === 'True'
                            ? 'Reject'
                            : 'Approve'
                    } ${dbName}?`
                )
            ) {
                return;
            }
            tableData[row.index] = {
                databaseName: dbName,
                clusterName: dbName,
                creatorEmail: row.getValue('creatorEmail'),
                scaleUpStatus: row.getValue('scaleUpStatus'),
                scaleDownStatus: row.getValue('scaleDownStatus'),
                scaleUpFrequency: row.getValue('scaleUpFrequency'),
                scaleUpConfig: row.getValue('scaleUpConfig'),
                scaleDownFrequency: row.getValue('scaleDownFrequency'),
                scaleDownConfig: row.getValue('scaleDownConfig'),
                scaleDownConfig: row.getValue('scaleDownConfig'),
                estimatedSaving: row.getValue('estimatedSaving'),
                slackChannelId: row.getValue('slackChannelId'),
                scaleUpLastRun: row.getValue('scaleUpLastRun'),
                scaleUpNextRun: row.getValue('scaleUpFrequency'),
                scaleDownLastRun: row.getValue('scaleDownLastRun'),
                scaleDownNextRun: row.getValue('scaleDownFrequency'),
                approvedStatus:
                    row.getValue('approvedStatus') === 'True'
                        ? 'False'
                        : 'True',
            };
            call(
                `/${
                    row.getValue('approvedStatus') === 'True'
                        ? 'reject'
                        : 'approve'
                }?databaseName=${encodeURIComponent(dbName)}`,
                null,
                'GET',
                setApproveLoader,
                row.index
            );
            setTableData([...tableData]);
        },
        [tableData]
    );
    const handleDeleteRow = useCallback(
        (row) => {
            var dbName = row.original?.databaseName ?? row.getValue('databaseName') ?? row.getValue('clusterName') ?? 'this config';
            if (
                !window.confirm(
                    `Are you sure you want to delete ${dbName}?`
                )
            ) {
                return;
            }
            var orig = row.original || {};
            var deletePayload = buildRedisTbasPayload(
                {
                    databaseName: orig.databaseName ?? row.getValue('databaseName') ?? row.getValue('clusterName'),
                    databaseId: orig.databaseId ?? row.getValue('databaseId'),
                    subscriptionId: orig.subscriptionId ?? row.getValue('subscriptionId'),
                    scaleUpFrequency: orig.scaleUpFrequency ?? row.getValue('scaleUpFrequency'),
                    scaleUpConfig: orig.scaleUpConfig ?? row.getValue('scaleUpConfig'),
                    scaleDownFrequency: orig.scaleDownFrequency ?? row.getValue('scaleDownFrequency'),
                    scaleDownConfig: orig.scaleDownConfig ?? row.getValue('scaleDownConfig'),
                    slackChannelId: orig.slackChannelId ?? row.getValue('slackChannelId'),
                    scaleUpStatus: orig.scaleUpStatus ?? row.getValue('scaleUpStatus'),
                    scaleDownStatus: orig.scaleDownStatus ?? row.getValue('scaleDownStatus'),
                    scaleUpLastRun: orig.scaleUpLastRun ?? row.getValue('scaleUpLastRun'),
                    scaleUpNextRun: orig.scaleUpNextRun ?? row.getValue('scaleUpNextRun'),
                    scaleDownLastRun: orig.scaleDownLastRun ?? row.getValue('scaleDownLastRun'),
                    scaleDownNextRun: orig.scaleDownNextRun ?? row.getValue('scaleDownNextRun'),
                    approvedStatus: orig.approvedStatus ?? row.getValue('approvedStatus'),
                    creatorEmail: orig.creatorEmail ?? row.getValue('creatorEmail'),
                },
                row
            );
            call('', deletePayload, 'DELETE', setDataLoader, -1);
            tableData.splice(row.index, 1);
            setTableData([...tableData]);
        },
        [tableData]
    );

    const getCommonEditTextFieldProps = useCallback(
        (cell) => {
            return {
                error: !!validationErrors[cell.id],
                helperText: validationErrors[cell.id],
                onBlur: (event) => {
                    const isValid = validateRequired(event.target.value);
                    if (!isValid) {
                        setValidationErrors({
                            ...validationErrors,
                            [cell.id]: `${cell.column.columnDef.header} is required`,
                        });
                    } else {
                        delete validationErrors[cell.id];
                        setValidationErrors({
                            ...validationErrors,
                        });
                    }
                },
            };
        },
        [validationErrors]
    );

    const columns = useMemo(
        () => [
            {
                accessorKey: 'databaseName',
                header: 'Database Name',
                enableEditing: false,
            },
            {
                accessorKey: 'creatorEmail',
                header: 'Creator Email',
                enableEditing: false,
            },
            {
                accessorKey: 'scaleUpStatus',
                header: 'Scale Up Status',
                Cell: ({ cell }) => <StatusPill value={cell.getValue()} />,
                enableEditing: false,
            },
            {
                accessorKey: 'scaleDownStatus',
                header: 'Scale Down Status',
                Cell: ({ cell }) => <StatusPill value={cell.getValue()} />,
                enableEditing: false,
            },
            {
                accessorKey: 'scaleUpFrequency',
                header: 'Scale Up Frequency',
            },
            {
                accessorKey: 'scaleUpDatasetSizeInGb',
                header: 'Scale Up Dataset (GB)',
                accessorFn: (row) => row.scaleUpConfig?.datasetSizeInGb ?? row.scaleUpConfig?.dataset_size_in_gb ?? '',
                muiTableBodyCellEditTextFieldProps: { type: 'number' },
            },
            {
                accessorKey: 'scaleUpThroughputOps',
                header: 'Scale Up Throughput (ops/sec)',
                accessorFn: (row) => row.scaleUpConfig?.throughputMeasurementValue ?? row.scaleUpConfig?.throughput_measurement_value ?? '',
                muiTableBodyCellEditTextFieldProps: { type: 'number' },
            },
            {
                accessorKey: 'scaleDownFrequency',
                header: 'Scale Down Frequency',
            },
            {
                accessorKey: 'scaleDownDatasetSizeInGb',
                header: 'Scale Down Dataset (GB)',
                accessorFn: (row) => row.scaleDownConfig?.datasetSizeInGb ?? row.scaleDownConfig?.dataset_size_in_gb ?? '',
                muiTableBodyCellEditTextFieldProps: { type: 'number' },
            },
            {
                accessorKey: 'scaleDownThroughputOps',
                header: 'Scale Down Throughput (ops/sec)',
                accessorFn: (row) => row.scaleDownConfig?.throughputMeasurementValue ?? row.scaleDownConfig?.throughput_measurement_value ?? '',
                muiTableBodyCellEditTextFieldProps: { type: 'number' },
            },
            // {
            //     accessorKey: 'estimatedSaving',
            //     header: 'Estimated Monthly Saving',
            //     Cell: ({ cell }) => (
            //         <Chip
            //             color="success"
            //             style={{ fontWeight: 'bolder' }}
            //             label={`${cell.getValue()?.toFixed(2)} $`}
            //         />
            //     ),
            //     enableEditing: false,
            // },
            {
                accessorKey: 'slackChannelId',
                header: 'Slack Channel Id',
            },
            {
                accessorKey: 'scaleUpLastRun',
                header: 'Scale Up Last Run',
                Cell: ({ cell }) =>
                    cell.getValue() === '' ? '' : parseTime(cell.getValue()),
                enableEditing: false,
            },
            {
                accessorKey: 'scaleUpNextRun',
                header: 'Scale Up Next Run',
                enableEditing: false,
            },
            {
                accessorKey: 'scaleDownLastRun',
                header: 'Scale Down Last Run',
                Cell: ({ cell }) =>
                    cell.getValue() === '' ? '' : parseTime(cell.getValue()),
                enableEditing: false,
            },
            {
                accessorKey: 'scaleDownNextRun',
                header: 'Scale Down Next Run',
                enableEditing: false,
            },
            {
                accessorKey: 'approvedStatus',
                header: 'Approved',
                enableEditing: false,
            },
        ],
        [getCommonEditTextFieldProps]
    );

    const csvOptions = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        useBom: true,
        useKeysAsHeaders: false,
        headers: columns.map((c) => c.header),
    };

    const csvExporter = new ExportToCsv(csvOptions);

    const handleExportData = () => {
        var data = [];
        for (var i = 0; i < tableData.length; i++) {
            var dict = {};
            dict['databaseName'] = tableData[i]['databaseName'] ?? tableData[i]['clusterName'];
            dict['clusterName'] = tableData[i]['clusterName'] ?? tableData[i]['databaseName'];
            dict['creatorEmail'] = tableData[i]['creatorEmail'];
            dict['scaleUpStatus'] = tableData[i]['scaleUpStatus'];
            dict['scaleDownStatus'] = tableData[i]['scaleDownStatus'];
            dict['scaleUpFrequency'] = tableData[i]['scaleUpFrequency'];
            dict['scaleUpConfig'] = tableData[i]['scaleUpConfig'];
            dict['scaleDownFrequency'] = tableData[i]['scaleDownFrequency'];
            dict['scaleDownConfig'] = tableData[i]['scaleDownConfig'];
            dict['estimatedSaving'] = tableData[i]['estimatedSaving'];
            dict['slackChannelId'] = tableData[i]['slackChannelId'];
            dict['scaleUpLastRun'] = tableData[i]['scaleUpLastRun'];
            dict['scaleUpNextRun'] = tableData[i]['scaleUpNextRun'];
            dict['scaleDownLastRun'] = tableData[i]['scaleDownLastRun'];
            dict['scaleDownNextRun'] = tableData[i]['scaleDownNextRun'];
            dict['approvedStatus'] = tableData[i]['approvedStatus'];
            data.push(dict);
        }
        csvExporter.generateCsv(data);
    };
    return (
        <>
            <MaterialReactTable
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        muiTableHeadCellProps: {
                            align: 'center',
                        },
                        size: 120,
                    },
                }}
                columns={columns}
                data={tableData}
                editingMode="modal" //default
                enableStickyFooter
                enableStickyHeader
                enableEditing
                enableDensityToggle={false}
                initialState={{
                    columnPinning: {
                        left: ['mrt-row-actions', 'databaseName'],
                    },
                    density: 'compact',
                }}
                state={{ isLoading: dataLoader }}
                onEditingRowSave={handleSaveRowEdits}
                renderRowActions={({ row, table }) => (
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '1rem',
                            fontWeight: 'bold',
                        }}
                    >
                        {editLoader[row.index] ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    fontWeight: 'bold',
                                    padding: '5px',
                                }}
                            >
                                <CircularProgress size={28} />
                            </Box>
                        ) : (
                            <Tooltip arrow placement="left" title="Edit">
                                <IconButton
                                    disabled={!isAdminApprover()}
                                    onClick={() => table.setEditingRow(row)}
                                >
                                    <Edit />
                                </IconButton>
                            </Tooltip>
                        )}

                        <Tooltip arrow placement="right" title="Delete">
                            <IconButton
                                color="error"
                                onClick={() => handleDeleteRow(row)}
                                disabled={!isAdminApprover()}
                            >
                                <Delete />
                            </IconButton>
                        </Tooltip>

                        {approveLoader[row.index] ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    fontWeight: 'bold',
                                    padding: '5px',
                                }}
                            >
                                <CircularProgress size={28} />
                            </Box>
                        ) : (
                            <Tooltip
                                arrow
                                placement="right"
                                title={
                                    row.getValue('approvedStatus') === 'True'
                                        ? 'Reject'
                                        : 'Approve'
                                }
                            >
                                {row.getValue('approvedStatus') === 'True' ? (
                                    <IconButton
                                        color="warning"
                                        onClick={() => handleApprove(row)}
                                        disabled={!isAdminApprover()}
                                    >
                                        <CancelIcon />
                                    </IconButton>
                                ) : (
                                    <IconButton
                                        color="success"
                                        onClick={() => handleApprove(row)}
                                        disabled={!isAdminApprover()}
                                    >
                                        <CheckCircleIcon />
                                    </IconButton>
                                )}
                            </Tooltip>
                        )}
                    </Box>
                )}
                renderTopToolbarCustomActions={() => (
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '1rem',
                            p: '0.5rem',
                            flexWrap: 'wrap',
                        }}
                    >
                        <Button
                            color="success"
                            onClick={() => setCreateModalOpen(true)}
                            variant="contained"
                        >
                            Add New Config
                        </Button>
                        <Button
                            color="primary"
                            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                            onClick={handleExportData}
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                        >
                            Export All Data
                        </Button>
                    </Box>
                )}
            />
            <AddNewJob
                columns={columns}
                open={createModalOpen}
                onClose={() => setCreateModalOpen(false)}
                onSubmit={handleCreateNewRow}
                clusters={clusters}
            />
        </>
    );
};

export const AddNewJob = ({ open, columns, onClose, onSubmit, clusters }) => {
    //const [open, setOpen] = React.useState(false);
    const [values, setValues] = useState(() =>
        columns.reduce((acc, column) => {
            acc[column.accessorKey ?? ''] = '';
            return acc;
        }, {})
    );
    const [clusterList, setClusterList] = useState([]);
    useEffect(() => {
        setClusterList(Object.keys(clusters || {}));
    }, [clusters]);
    const dateObj = new Date();
    const { user } = useAuth();
    const [cluster, setCluster] = useState(clusterList[0]);
    const [scaleUpDatasetSizeInGb, setScaleUpDatasetSizeInGb] = useState('');
    const [scaleUpThroughputOps, setScaleUpThroughputOps] = useState('');
    const [scaleDownDatasetSizeInGb, setScaleDownDatasetSizeInGb] = useState('');
    const [scaleDownThroughputOps, setScaleDownThroughputOps] = useState('');
    const [scaleUpFrequency, setScaleUpFrequency] = useState(dateObj);
    const [scaleDownFrequency, setScaleDownFrequency] = useState(dateObj);
    const [estimatedSaving, setEstimatedSaving] = useState(0);

    const allowIntegerOnly = (val) => {
        if (val === '' || val === null || val === undefined) return '';
        const str = String(val).replace(/\D/g, '');
        return str === '' ? '' : str;
    };

    useEffect(() => {
        setCluster(clusterList[0]);
    }, [clusterList]);

    useEffect(() => {
        var upGb = parseInt(scaleUpDatasetSizeInGb, 10);
        var upOps = parseInt(scaleUpThroughputOps, 10);
        var downGb = parseInt(scaleDownDatasetSizeInGb, 10);
        var downOps = parseInt(scaleDownThroughputOps, 10);
        if (!isNaN(upGb) && !isNaN(upOps) && !isNaN(downGb) && !isNaN(downOps)) {
            setEstimatedSaving(
                (
                    getCronDifference(
                        getCron(scaleUpFrequency.toISOString()),
                        getCron(scaleDownFrequency.toISOString())
                    ) *
                    (Math.abs(upGb - downGb) + Math.abs(upOps - downOps)) *
                    0.1 *
                    30
                ).toFixed(2)
            );
        } else {
            setEstimatedSaving(0);
        }
    }, [
        scaleUpDatasetSizeInGb,
        scaleUpThroughputOps,
        scaleDownDatasetSizeInGb,
        scaleDownThroughputOps,
        scaleUpFrequency,
        scaleDownFrequency,
    ]);

    const handleSubmit = () => {
        if (values['slackChannelId'] === '') {
            alert('Provide Slack Channel Id');
            return;
        }
        var upGb = parseInt(scaleUpDatasetSizeInGb, 10);
        var upOps = parseInt(scaleUpThroughputOps, 10);
        var downGb = parseInt(scaleDownDatasetSizeInGb, 10);
        var downOps = parseInt(scaleDownThroughputOps, 10);
        if (
            scaleUpDatasetSizeInGb === '' || scaleUpThroughputOps === '' ||
            scaleDownDatasetSizeInGb === '' || scaleDownThroughputOps === '' ||
            isNaN(upGb) || isNaN(upOps) || isNaN(downGb) || isNaN(downOps)
        ) {
            alert('Please enter valid integers for all Scale Up and Scale Down config fields (Dataset Size GB and Throughput ops/sec)');
            return;
        }
        // if (compareTime(scaleUpFrequency, scaleDownFrequency)) {
        //     alert(
        //         'Difference between ScaleUp and ScaleDown Frequency should be atleast greater than 30 min'
        //     );
        //     return;
        // }

        var selectedInstance = clusters && cluster ? (clusters[cluster] || {}) : {};
        onSubmit({
            ...values,
            databaseName: cluster,
            clusterName: cluster,
            databaseId: selectedInstance.databaseId ?? selectedInstance.database_id ?? '',
            subscriptionId: selectedInstance.subscriptionId ?? selectedInstance.subscription_id ?? '',
            creatorEmail: user.email,
            approvedStatus: 'False',
            scaleUpConfig: {
                datasetSizeInGb: upGb,
                throughputMeasurementValue: upOps,
            },
            scaleDownConfig: {
                datasetSizeInGb: downGb,
                throughputMeasurementValue: downOps,
            },
            scaleUpFrequency: scaleUpFrequency.toISOString(),
            scaleDownFrequency: scaleDownFrequency.toISOString(),
            scaleUpStatus: '',
            scaleDownStatus: '',
            scaleUpLastRun: '',
            scaleDownLastRun: '',
        });
        onClose();
    };
    return (
        <>
            <Dialog open={open}>
                <DialogTitle textAlign="center">
                    <div>Add New Instance</div>
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <Stack
                            sx={{
                                width: '100%',
                                minWidth: {
                                    xs: '300px',
                                    sm: '360px',
                                    md: '400px',
                                },
                                gap: '1.5rem',
                                marginTop: '21px',
                            }}
                        >
                            {(() => {
                                return (
                                    <>
                                        <div className="text-left relative z-1">
                                            <div>
                                                <SearchDD
                                                    label={'Instance Name'}
                                                    emptyLabel={
                                                        'Select Instance'
                                                    }
                                                    options={clusterList}
                                                    value={cluster}
                                                    onChange={setCluster}
                                                    disabled={false}
                                                />
                                            </div>
                                        </div>

                                        <TimePickerInput
                                            label={'Scale Up Frequency'}
                                            value={scaleUpFrequency}
                                            onChange={(item) => {
                                                setScaleUpFrequency(
                                                    new Date(item.toISOString())
                                                );
                                            }}
                                        />

                                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mt: 1 }}>Scale Up Config</Typography>
                                        <div className="text-left relative z-0 mt-1">
                                            <TextField
                                                label="Dataset Size (GB)"
                                                value={scaleUpDatasetSizeInGb}
                                                onChange={(e) =>
                                                    setScaleUpDatasetSizeInGb(allowIntegerOnly(e.target.value))
                                                }
                                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                                placeholder="Enter integer"
                                                sx={{ width: '400px', mr: 1 }}
                                            />
                                        </div>
                                        <div className="text-left relative z-0 mt-1">
                                            <TextField
                                                label="Throughput (ops/sec)"
                                                value={scaleUpThroughputOps}
                                                onChange={(e) =>
                                                    setScaleUpThroughputOps(allowIntegerOnly(e.target.value))
                                                }
                                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                                placeholder="Enter integer"
                                                sx={{ width: '400px' }}
                                            />
                                        </div>

                                        <TimePickerInput
                                            label={'Scale Down Frequency'}
                                            value={scaleDownFrequency}
                                            onChange={(item) => {
                                                setScaleDownFrequency(
                                                    new Date(item.toISOString())
                                                );
                                            }}
                                        />

                                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mt: 1 }}>Scale Down Config</Typography>
                                        <div className="text-left relative z-0 mt-1">
                                            <TextField
                                                label="Dataset Size (GB)"
                                                value={scaleDownDatasetSizeInGb}
                                                onChange={(e) =>
                                                    setScaleDownDatasetSizeInGb(allowIntegerOnly(e.target.value))
                                                }
                                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                                placeholder="Enter integer"
                                                sx={{ width: '400px' }}
                                            />
                                        </div>
                                        <div className="text-left relative z-0 mt-1">
                                            <TextField
                                                label="Throughput (ops/sec)"
                                                value={scaleDownThroughputOps}
                                                onChange={(e) =>
                                                    setScaleDownThroughputOps(allowIntegerOnly(e.target.value))
                                                }
                                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                                placeholder="Enter integer"
                                                sx={{ width: '400px' }}
                                            />
                                        </div>

                                        <TextField
                                            key="slackChannelId"
                                            label="Slack Channel Id"
                                            name="slackChannelId"
                                            value={values['slackChannelId'] ?? ''}
                                            onChange={(e) =>
                                                setValues({
                                                    ...values,
                                                    slackChannelId: e.target.value,
                                                })
                                            }
                                            placeholder="Enter Slack Channel Id"
                                            sx={{ width: '400px' }}
                                        />
                                        {/* <Typography
                                            style={{
                                                textAlign: 'center',
                                                fontFamily: 'serif',
                                                fontWeight: 'bold',
                                                color: 'green',
                                                fontSize: '19.5px',
                                            }}
                                        >{`You are saving around ${estimatedSaving}$ per month`}</Typography> */}
                                    </>
                                );
                            })()}
                        </Stack>
                    </form>
                </DialogContent>
                <DialogActions sx={{ p: '1.25rem' }}>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button
                        color="secondary"
                        onClick={handleSubmit}
                        variant="contained"
                    >
                        Add New Job
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const validateRequired = (value) => !!value.length;
const validateEmail = (email) =>
    !!email.length &&
    email
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );

export default RedisTbasTable;
